import { Injectable, computed, signal } from '@angular/core';

/**
 * Quantos modais da Agenda estão abertos. A atualização automática da grade não roda com modal
 * aberto (repintar por baixo tiraria do operador a linha que ele está editando). Cada modal
 * chama abrir() ao aparecer e a função devolvida ao fechar (inclusive no ngOnDestroy).
 */
@Injectable({ providedIn: 'root' })
export class AgendaModaisService {
  private readonly abertos = signal(0);
  readonly algumAberto = computed(() => this.abertos() > 0);
  /** Painel por baixo de um modal do dashboard: o Esc é de quem está por cima. */
  readonly coberto = signal(false);

  /** Devolve quem fecha; chamar mais de uma vez não desconta duas vezes. */
  abrir(): () => void {
    this.abertos.update(n => n + 1);
    let fechado = false;
    return () => {
      if (fechado) return;
      fechado = true;
      this.abertos.update(n => Math.max(0, n - 1));
    };
  }
}
